import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { Notice, StatusDot } from '../components/ui';
import { formatAgo } from '../format';

export function Gateways() {
  const gateways = useQuery({ queryKey: ['gateways'], queryFn: api.gateways });

  if (gateways.isLoading) return <p className="muted">Caricamento…</p>;
  if (gateways.error) return <Notice variant="error">{(gateways.error as Error).message}</Notice>;

  const list = gateways.data ?? [];
  if (list.length === 0) {
    return (
      <Notice>
        Nessun gateway registrato. Accendi il gateway LoRa: si registra da solo alla prima
        connessione WiFi.
      </Notice>
    );
  }

  return (
    <div className="stack">
      {list.map((gateway) => (
        <section key={gateway.id} className="card stack" style={{ gap: 12 }}>
          <div className="row row-wrap">
            <StatusDot online={gateway.online} />
            <strong>{gateway.name}</strong>
            <span className="small muted">
              {gateway.ip ?? 'IP sconosciuto'} · {formatAgo(gateway.lastSeenAt)}
              {gateway.fwVersion && ` · fw ${gateway.fwVersion}`}
            </span>
          </div>

          {!gateway.online && (
            <Notice variant="warning">
              Il gateway non risponde da più di un minuto: i nodi LoRa continuano a seguire l&apos;ultimo
              piano ricevuto, ma i comandi manuali non vengono consegnati.
            </Notice>
          )}

          {gateway.nodes.length === 0 ? (
            <p className="small muted" style={{ margin: 0 }}>
              Nessun nodo ancora rilevato su questo gateway.
            </p>
          ) : (
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Nodo</th>
                    <th>Nome</th>
                    <th>Ultimo contatto</th>
                  </tr>
                </thead>
                <tbody>
                  {gateway.nodes.map((node) => (
                    <tr key={node.deviceId}>
                      <td className="num">{node.nodeId}</td>
                      <td style={{ color: 'var(--text-primary)' }}>
                        <Link to={`/devices/${node.deviceId}`}>{node.name}</Link>
                      </td>
                      <td>{formatAgo(node.lastSeenAt)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
      ))}
    </div>
  );
}
